import type { IconSvgObject } from './types';

const XVariableSquareIcon: IconSvgObject = [
  ["path", { d: "M2.5 19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50043C21.5 3.39589 20.6046 2.50046 19.5001 2.50043L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 8H8.76393C9.52148 8 10.214 8.428 10.5528 9.10557L13.4472 14.8944C13.786 15.572 14.4785 16 15.2361 16H16.5M17 8H16.4075C15.8308 8 15.2822 8.24896 14.9024 8.68299L9.09762 15.317C8.71784 15.751 8.16919 16 7.59246 16H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default XVariableSquareIcon;
